import React, { useEffect } from 'react'

const useCaseComponent = ({item}) => {
  const {mainText, secondaryText, thisdText, patagraphHero, places, image} = item;

  useEffect(() => {
    
  }, [item])
 
  return (
    <div className="UseCasesContainer">
    <div className="leftSection">
      <h1 className="MainText">
        {mainText}<br />
        <span className="secondaryText">
          {secondaryText}<br /> {thisdText}
        </span>
      </h1>
      <p className="patagraphHero">
        {patagraphHero[0]}<br />{patagraphHero[1]}<br /> {patagraphHero[2]}<br /> {patagraphHero[3]}
      </p>
      <p className="placesParagraph">REPLACES</p>
      <ul className="placesUl">
        <li  >
          <a href="#">{places[0]}</a>
        </li>
        <li>
          <a href="#">{places[1]}</a>
        </li>
        <li>
          <a href="#">{places[2]}</a>
        </li>
        <li id="lastItem" >
          <a href="#">{places[3]}</a>
        </li>
      </ul>
    </div>
    <div className="rightUseSection">
      <img className="rightUseImage" src={image} />
    </div>
  </div>
  )
}

export default useCaseComponent